import { FormCentralizer, Loading } from '@/components';
import { useId } from '@/hooks';
import { useMessage } from '@/providers';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { RoleForm } from '../_components/RoleForm';
import { useRole, useUpdateRole } from '../_hooks/role';

export const UpdateRolePage: FC = () => {
  const navigate = useNavigate();
  const { openMessage } = useMessage();
  const { t } = useTranslation();
  const { id } = useId();
  const { mutateAsync: updateRole } = useUpdateRole();
  const role = useRole(id);

  if (role.isPending || !role.data) {
    return <Loading />;
  }

  return (
    <FormCentralizer width={530}>
      <RoleForm
        initialValues={{
          ...role.data,
        }}
        onSubmit={async (values) => {
          try {
            await updateRole({ id, ...values });

            await Promise.all([
              openMessage('success', t('message-save-completed')),
              (async () => {
                navigate(`/tenant-manager/roles/${id}`, {
                  replace: true,
                });
              })(),
            ]);
          } catch {
            await openMessage('error', t('message-save-failed'));
          }
        }}
      />
    </FormCentralizer>
  );
};
